<template>
  <div v-if="attachment" class="files-group">
      <div class="files-item" @click="downloadFiles(item)" v-for="item,index in attachment" :key="index">{{item.name}}</div>
  </div>
</template>

<script>
import axios from 'axios';
import services from '../../../config/services'
export default {
  name: "questionFiles",
  props: ["attachment"],
  data() {
    return {
      services,
      downloadProgress: 0, // 文件下载进度
      downloadShow: false, // 文件下载进度是否显示
    };
  },
  methods: {
    // 下载试题附近方法
    downloadFiles(item) {
      let str = item.name.split(".");
      if (str && str.length > 1) {
        if (str[1] == "mp4" || str[1] == "mp3") {
          this.downloadVideo(
            `${services.XUEXI_SERVER}/api/my/tk/exercises/question/download?id=${item.id}`,
            str[0],
            str[str.length - 1]
          );
        } else {
          this.downloadFile(item);
        }
      }
    },
    // 素材下载 - 视频
    async downloadVideo(fileUrl, fileName, format) {
      const filePath = fileUrl; // 文件地址
      let that = this;
      that.downloadProgress = 0;
      that.downloadShow = true;
      let res = await fetch(fileUrl, { credentials: "include" }); // include 跨域携带cookie
      const reader = res.body.getReader();
      const contentLength = +res.headers.get("Content-Length");
      // Step 3：读取数据
      let receivedLength = 0; // 当前接收到了这么多字节
      let chunks = []; // 接收到的二进制块的数组（包括 body）
      let isforce = true
      while (isforce) {
        const { done, value } = await reader.read();
        if (done) {
          that.downloadProgress = 0;
          that.downloadShow = false;
          break;
        }
        chunks.push(value);
        receivedLength += value.length;
        that.downloadProgress = parseInt(
          (receivedLength / contentLength) * 100
        );
      }
      let blob = new Blob(chunks);
      let newUrl = window.URL.createObjectURL(blob);
      this.createUrlBlob(newUrl, fileName + "." + format);
    },
    // 素材下载 - 文件类型
    downloadFile(row) {
      let that = this;
      that.downloadProgress = 0;
      that.downloadShow = true;
      axios({
        url: services.XUEXI_SERVER + "/api/my/tk/exercises/question/download",
        params: { id: row.id },
        method: "post",
        responseType: "arraybuffer",
        onDownloadProgress(evt) {
          // that.downloadProgress = parseInt((evt.loaded / row.size_byte) * 100)
        },
      })
        .then((res) => {
          that.downloadShow = false;
          if (res.status == 200 && res.data) {
            let newUrl = window.URL.createObjectURL(new Blob([res.data]));
            that.createUrlBlob(newUrl, row.name);
          } else {
            that.$errorMsg("文件下载失败");
          }
        })
        .catch(() => {
          that.downloadProgress = 0;
          that.downloadShow = false;
        });
    },
    // 文件流统一处理
    createUrlBlob (url, fileName) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', fileName);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
  },
};
</script>

<style lang="less" scoped>
.files-group {
  display: block;
  font-weight: 400;
  color: #3377ff;
  line-height: 26px;
  font-size: 12px;
  .files-item {
    color: #3377ff;
    line-height: 26px;
    font-size: 12px;
    cursor: pointer;
    &::before {
      content: "附件";
      display: inline-block;
      width: 36px;
      color: #ffffff;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 10px;
      background: #3377ff;
      border-radius: 8px 9px 9px 0px;
      margin-right: 6px;
    }
  }
}
</style>